import { baseAxiosInstance } from '../http-client'

import {
  getApplicationID,
  getServiceWorkerEndpoint,
  getStoredLogin,
  getStoredRefreshToken,
  isRunningInWebview,
  removeServiceWorkerEndpoint,
  storeLogout,
} from '../graphql-client/storedState'
import * as serviceWorker from '../serviceWorker'
import { canSendMessageToWebView, sendMessageToWebView } from './react-native'
import { WebMessageType } from './react-native/types'


export const logout = async () => {
  const applicationId = getApplicationID()
  const authorization = getStoredLogin()
  const refreshToken = getStoredRefreshToken()

  try {
    await baseAxiosInstance.post('/auth/session/logout', {
      pushSubscriptionEndpoint: getServiceWorkerEndpoint(),
      applicationId,
    }, {
      headers: {
        Authorization: `Bearer ${authorization}`,
        'X-Refresh-Token': `${refreshToken}`,
      },
    })
  } finally {
    if(isRunningInWebview()) {
      canSendMessageToWebView() && sendMessageToWebView({ type: WebMessageType.LOGOUT })
    } else {
      removeServiceWorkerEndpoint()
      serviceWorker.unregister()
    }
   
    storeLogout()
  }
}
